import { useQueryParams } from '@terminal/hooks/use-query-params/useQueryParams';
import { queryKeys, queryValues } from '@terminal/routes/query-params';

import { SubTabsType } from '../ThemeWidget';

export const useThemeDrawer = () => {
  const { deleteQueryParam, setQueryParams, params } = useQueryParams();
  const themeId = params[queryKeys.themeId];
  const isDrawerOpen =
    params[queryKeys.activeDrawer] === queryValues.themeDrawer;

  const openDrawer = (themeId: string) =>
    setQueryParams({
      [queryKeys.activeDrawer]: queryValues.themeDrawer,
      [queryKeys.activeDrawerTab]: SubTabsType.ThemeExposure,
      [queryKeys.themeId]: themeId,
    });

  const closeDrawer = () =>
    deleteQueryParam([
      queryKeys.activeDrawer,
      queryKeys.activeDrawerTab,
      queryKeys.themeId,
      queryKeys.competitorTag,
    ]);

  return {
    closeDrawer,
    openDrawer,
    isDrawerOpen,
    themeId,
  };
};
